import React, { useState, useEffect, useContext } from 'react';
import styled from 'styled-components';
import { NormalContainer, Heading, SubHeading, Divider, MiniHeading, MiniSubHeading, Loader } from '../global-styles';
import { ButtonMailto, SocialIcons } from '../components'
import loader from '../assets/loader.svg'
import { ProjectContext } from '../context/ProjectContext'
import getData from '../helpers/getData'

export default function Home() {

    const [loading, setLoading ] = useState(true);
    const { projects, setProjects } = useContext(ProjectContext);


    useEffect(() =>{
        setTimeout(() => {
            setLoading(false);
        }, 1500);
    }, []);

    getData(setProjects);
    var featured = projects ? projects.slice(0, 2): [];
    return !loading ? (
        <React.Fragment>
            <Container>
                <MainSection>
                    <Heading>
                        Full Stack Web Developer learning &amp; creating multi-platform applications.
                    </Heading>
                    <SubHeading>
                        I’m Vinayak Singh, an India based web developer with a passion to create applications that cater to the need of the people and also to keep updating myself with newer technologies.
                    </SubHeading>
                    <SubHeading>
                        I'm an open-source developer with my interests ranging from the field of Web Development to Cybersecurity, PWAs, Flutter Development and what not! - I'm always in for more knowledge, fun and challenges!!
                    </SubHeading>
                    <Socials>
                        <SocialIcons />
                        <ButtonMailto label="Email me" mailto="mailto:vinayak.btech.ec19@iiitranchi.ac.in" />
                    </Socials>
                </MainSection>
                <Divider />
                <FeaturedProjects>
                    {
                        <>
                            <MiniHeading>
                                Featured Projects
                            </MiniHeading>
                            <MiniSubHeading>
                                A collection of some side projects that I have created recently.
                            </MiniSubHeading>
                            {featured.length > 0 ?
                                featured.map((p,i) => 
                                <Project key={i} rel='noreferrer' href={p.url} target={"_blank"}>
                                    <Col>
                                            <Image src={p.img_src} />
                                    </Col>
                                    <Col>
                                            <PrHeading>
                                                {p.name}
                                            </PrHeading>
                                            <PrSubHeading>
                                                {p.description}
                                                {p.tech}
                                            </PrSubHeading>
                                    </Col>
                                </Project>): null
                            }
                        </>
                    }
                </FeaturedProjects>
            </Container>
        </React.Fragment>
    ) :
        <Loader>
            <img src={loader} alt="" />
        </Loader>
}

const Container = styled(NormalContainer)`
    padding: 0;
    margin: 48px auto;
    max-width: 1000px;
    min-height: 100vh;

    @media screen and (max-width: 991px){
        padding: 0 30px;
    }
`;

const MainSection = styled.div`
    display:flex;
    flex-flow: column wrap;
    align-items: center;
    justify-content: center;`;

const Socials = styled.div`
    margin-top: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 40%;
    color: #fff;

    @media screen and (max-width: 991px){
        width: 100%;
    }
    
`;

const FeaturedProjects = styled.div`
    display: flex;
    flex-flow: column wrap;
    align-items: flex-start;
    justify-content: center;
`;

const Project = styled.a`
    text-decoration: none;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    background: #292929;
    padding: 25px;
    margin: 15px 0;
    border-radius: 10px;
    cursor: pointer;

    &:hover {
        background: #474747;
    }

    @media screen and (max-width: 991px){
        flex-direction: column;
    }
`;

const Col = styled.div`
    display: flex;
    flex-flow: column wrap;
    align-items: flex-start;
    justify-content: space-around;
    margin: 0 15px;
`;

const PrHeading = styled(MiniHeading)`
    font-size: 1.5rem;
    margin-bottom: 0;
    color: #eaeaea;
`;

const PrSubHeading = styled(SubHeading)`
    font-size: 1rem;
    margin-bottom: 0;
    margin-top: 10px;
    line-height:2em;
`;

const Image = styled.img`
    width: 100px;
    height: 100px;
    border-radius: 10px;

    transition: transform 750ms cubic-bezier(.5, 0, .5, 1),
        opacity 250ms linear;

        &:hover,
        &:focus {
            transform: scale(1.1);
            opacity: .8;
        }

    @media screen and (max-width: 991px){
        width: 240px;
        height: 240px;
        margin-bottom: 15px;
    }
`;